// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fcbc8ebe","455":"55b8f786","977":"53a5586f"}[chunkId] + ".chunk.js";
};